/**
 * Retrieves entries from Firebase LocalStorage IndexedDB
 * 
 * This function opens the Firebase LocalStorage database and fetches all entries
 * from the firebaseLocalStorage object store. It handles errors gracefully and
 * returns the data or false if an error occurs.
 * 
 * @returns {Promise<any[]|boolean>} Array of entries or false if error
 */
export function getFirebaseLocalStorageEntry() {
    return new Promise((resolve, reject) => {
        try {
            const request = indexedDB.open("firebaseLocalStorageDb");
            let result = {};
            
            request.onerror = function(event) {
                console.error("Error opening IndexedDB:", event.target.error);
                resolve(false);
            };
          
            request.onsuccess = function(event) {
                const db = event.target.result;
                const transaction = db.transaction(["firebaseLocalStorage"], "readonly");
                const store = transaction.objectStore("firebaseLocalStorage");
                const getAllRequest = store.getAll();
                
                getAllRequest.onsuccess = function() {
                    result = getAllRequest.result;
                    resolve(result);
                };
                
                getAllRequest.onerror = function(event) {
                    console.error("Error fetching all entries:", event.target.error);
                    resolve(false);
                };
            };
        } catch (error) {
            console.error("Unexpected error accessing IndexedDB:", error);
            resolve(false);
        } 
    });
}
